<script>
  import ImageLightbox from '@components/messenger/previews/ImageLightbox.svelte';

  export let images = [];
  export let index = 0;
  export let onClose = () => {};
</script>

<ImageLightbox {images} bind:index {onClose} />
